<template>
  <VcWidget
    class="footer-links"
    size="xs"
    :border="false"
    :shadow="false"
    :collapsible="isMobile"
    :collapsed="isMobile"
  >
    <template #header-container="{ collapsible, collapsed }">
      <span class="footer-links__header">
        <span class="footer-links__title text-base">{{ $t("shared.layout.footer.contact-info.title") }}</span>

        <VcIcon
          v-if="collapsible"
          :size="16"
          :class="['footer-links__arrow', { 'footer-links__arrow--rotate': collapsed }]"
          name="chevron-up"
        />
      </span>
    </template>

    <template #default-container>
      <a
        :href="$t('shared.layout.footer.contact-info.google-url')"
        target="_blank"
        rel="noopener noreferrer nofollow"
        class="footer-link mt-[6px]"
        v-html-safe="$t('shared.layout.footer.contact-info.text').replace(/\*/g, '<br/>')"
      ></a>

      <a
        href="tel:+31363032000"
        target="_blank"
        rel="noopener noreferrer nofollow"
        class="footer-link mt-[6px] md:mt-[24px]"
        ><VcIcon name="phone" size="sm" class="mr-2 opacity-40" />+31 ( 0 ) 36 303 2000</a
      >

      <a
        href="mailto:bnl_sales@bossard.com"
        target="_blank"
        rel="noopener noreferrer nofollow"
        class="footer-link mt-[6px] mb-2"
        ><VcIcon name="mail" size="sm" class="mr-2 opacity-40" />bnl_sales@bossard.com</a
      >
    </template>
  </VcWidget>
</template>

<script setup lang="ts">
import { useBreakpoints } from "@vueuse/core";
import { BREAKPOINTS } from "@/core/constants";

const breakpoints = useBreakpoints(BREAKPOINTS);
const isMobile = breakpoints.smaller("sm");
</script>
